const CERTIFICATE_YEAR_MIN = 2019;

export function getCertificateYearOptions(now = new Date()): number[] {
	const currentYear = now.getFullYear();
	const years: number[] = [];

	for (let year = currentYear; year >= CERTIFICATE_YEAR_MIN; year -= 1) {
		years.push(year);
	}

	return years;
}

export function getDefaultCertificateYear(now = new Date()): number {
	return now.getFullYear();
}
